import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.66667 6.33317C4.29848 6.33317 4 6.63165 4 6.99984C4 7.36803 4.29848 7.6665 4.66667 7.6665H11.3333C11.7015 7.6665 12 7.36803 12 6.99984C12 6.63165 11.7015 6.33317 11.3333 6.33317H4.66667Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 2.33317C6 1.96498 5.70152 1.6665 5.33333 1.6665C4.96514 1.6665 4.66667 1.96498 4.66667 2.33317V2.99984H4C2.89543 2.99984 2 3.89527 2 4.99984V12.3332C2 13.4377 2.89543 14.3332 4 14.3332H12C13.1046 14.3332 14 13.4377 14 12.3332V4.99984C14 3.89527 13.1046 2.99984 12 2.99984H11.3333V2.33317C11.3333 1.96498 11.0349 1.6665 10.6667 1.6665C10.2985 1.6665 10 1.96498 10 2.33317V2.99984H6V2.33317ZM4 4.33317H4.66667C4.66667 4.70136 4.96514 4.99984 5.33333 4.99984C5.70152 4.99984 6 4.70136 6 4.33317H10C10 4.70136 10.2985 4.99984 10.6667 4.99984C11.0349 4.99984 11.3333 4.70136 11.3333 4.33317H12C12.3682 4.33317 12.6667 4.63165 12.6667 4.99984V12.3332C12.6667 12.7014 12.3682 12.9998 12 12.9998H4C3.63181 12.9998 3.33333 12.7014 3.33333 12.3332V4.99984C3.33333 4.63165 3.63181 4.33317 4 4.33317Z",
		fill: "currentColor"
	})]
});
export default SvgIcCalendar;
